import { EventCatalogFromKeys, EventType } from "../../../types";

export const AreaMetricsEventKeys = {
  AREA_METRICS_CLIENT_EXPORT: "area-metrics-client-export",
} as const;

export const AreaMetricsEventCatalog: EventCatalogFromKeys<
  typeof AreaMetricsEventKeys
> = {
  [AreaMetricsEventKeys.AREA_METRICS_CLIENT_EXPORT]: {
    description: "User exported data in AreaMetricsClient",
    eventType: EventType.INTERACTION,
    id: AreaMetricsEventKeys.AREA_METRICS_CLIENT_EXPORT,
  },
};
